import addWindowScrollPositionToDocument from './modules/viewport';
import swiper from './modules/swiper';
import './modules/featherlight';

try {
  window.$ = window.jQuery = require('jquery');
} catch (e) {
}

addWindowScrollPositionToDocument();
swiper.referencesHome();
swiper.referencesMultiple();

$('.toggle-navbar').click(function (e) {
  e.stopPropagation();
  $('#navbar').toggleClass('translate-x-full');
  $('body').toggleClass('overflow-hidden');
});

$('body,html').click(function (e) {
  $('#navbar').addClass('translate-x-full');
  $('body').removeClass('overflow-hidden');
});
